/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userBusinessUsedCoupons.internal

import features.userBusinessUsedCoupons.models.UserBusinessCouponsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.userBusinessUsedCoupons.internal.UserBusinessUsedCouponsUseCase.Params

internal class UserBusinessUsedCouponsUseCase : AsyncUseCase<UserBusinessCouponsModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val businessId: String
    )

    private val userBusinessUsedCouponsService: UserBusinessUsedCouponsService = UserBusinessUsedCouponsServiceImpl()

    override suspend fun run(params: Params): Result<UserBusinessCouponsModel> {
        return userBusinessUsedCouponsService.getUserBusinessUsedCoupons(
            overrideHeaders = params.overrideHeaders,
            businessId = params.businessId
        )
    }
}
